<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Past Conversations" class="d-icon d-icon--past-conversations" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M1.646 7.646a.5.5 0 1 1 .708.708L1.707 9H9a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 9 3H4.5a.5.5 0 0 0-.5.5V6a.5.5 0 1 1-1 0V3.5A1.5 1.5 0 0 1 4.5 2H9a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 9 10H1.707l.647.646a.5.5 0 1 1-.708.707l-1.5-1.5a.5.5 0 0 1 0-.707l1.5-1.5ZM7.5 7.25a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h2.5Zm1-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Zm0-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPastConversations',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
